/**
 * A single tab page. Renders via ngTemplateOutlet + ng-content.
 */

import { Component, Input } from '@angular/core';

@Component({
    selector: 'my-tab',
    styles: [
    `
    .pane{
      padding: 1em;

    }

    .dashboard-pane{
      background:none
    }
    
  `
  ],
  template:
  `
    <div [hidden]="!active" class="pane" [ngClass]="{'dashboard-pane':title=='Dashboard'}" [attr.data-tab-id]="dataContext?.id">
      <ng-content></ng-content>
      <ng-container *ngIf="template"
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ inputDataContext: dataContext }"
      >
      </ng-container>
    </div>
  `
})
export class TabComponent {
  @Input('tabTitle') title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() dataContext;

  // breadcrumb
  @Input() breadcrumbpath: any[]=[];

  // Optional reference to the dynamic component instance (for cleanup)
  componentRef?: any;
}
